"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDistributorProductWithOffers = void 0;
const routes_1 = require("../../routes");
const getDistributorProductWithOffers = (client) => async (params) => {
    const url = routes_1.ENDPOINTS.GET_DISTRIBUTOR_PRODUCT_WITH_OFFERS.applyParams({
        distributorId: params.distributorId,
        productId: params.productId,
    });
    const response = await client.get(url, {
        headers: {
            'x-beneficiary-id': params.beneficiaryId,
            ...(params.locale ? { 'idf-locale': params.locale } : {}),
        },
        params: {
            ...(params.variantIds.length > 0 ? { variantIds: params.variantIds.join(',') } : {}),
        },
    });
    return response.data;
};
exports.getDistributorProductWithOffers = getDistributorProductWithOffers;
